import axios from 'axios';
import { getFromLocalStorage } from 'helpers/LocalStorage';
import { getStoredId } from 'helpers/LocalStorage';
import { store } from 'store';
import { toast } from 'react-toastify';
// actions
import { setIsLoggedInFalse } from 'store/app/AppActions';

const createNewBaseUrl = (url) =>
  axios.create({
    baseURL: url,
  });

const apiQuerytaskService = createNewBaseUrl(process.env.REACT_APP_QUERYTASK),
  apiGatewayService = createNewBaseUrl(process.env.REACT_APP_API_GATEWAY ),
  apiFloristGatewayService = createNewBaseUrl(process.env.REACT_APP_FLORIST_API_GATEWAY);
const requestInterceptor = (config) => {
  // A missing ops centre is stored as the literal "null" - sending that as the header
  // gets the request rejected, so leave the header off instead.
  const opsId = getStoredId('opsId');
  if (opsId) {
    config.headers['opsId'] = opsId;
  }
  config.headers['Authorization'] = `Bearer ${getFromLocalStorage('token')}`;

  return config;
};

const requestInterceptorError = (error) => {
  return Promise.reject(error);
};

const responseInterceptor = (response) => {
  return response;
};

const responseInterceptorError = (error) => {
  if (error.response) {
    if (error.response.status === 401) {
      toast.error('401 Unauthorized');
      store.dispatch(setIsLoggedInFalse());
    }
  }

  return Promise.reject(error);
};


const addInterceptors = (service) => {
  service.interceptors.request.use(requestInterceptor, requestInterceptorError);
  service.interceptors.response.use(responseInterceptor, responseInterceptorError);
};

addInterceptors(apiQuerytaskService);
addInterceptors(apiGatewayService);
addInterceptors(apiFloristGatewayService);

export { apiQuerytaskService, apiGatewayService, apiFloristGatewayService };
